<form [formGroup]="form" class="form-container">
  <div class="form-field-container form-field-container-with-columns">
    <mat-form-field appearance="fill" class="form-field" [class.locked-field]="lockNameAndCategories">
      <mat-label>Name</mat-label>
      <input matInput formControlName="pyramidName" required [readonly]="lockNameAndCategories" appTextNormalize>
      @if (lockNameAndCategories) {
        <mat-icon matSuffix class="lock-icon">lock</mat-icon>
      }
    </mat-form-field>
    <mat-form-field appearance="fill" class="form-field" [class.locked-field]="lockNameAndCategories">
      <mat-label>Category</mat-label>
      <mat-select formControlName="category" [compareWith]="compareById">
        @for (category of categories; track category.id) {
          <mat-option [value]="category">
            {{ category.name }}
          </mat-option>
        }
      </mat-select>
      @if (lockNameAndCategories) {
        <mat-icon matSuffix class="lock-icon">lock</mat-icon>
      }
    </mat-form-field>
    <mat-form-field appearance="fill" class="form-field" [class.locked-field]="lockNameAndCategories">
      <mat-label>Subcategory</mat-label>
      <mat-select formControlName="subcategory" [disabled]="lockNameAndCategories || !form.get('category')?.value" [compareWith]="compareById">
        @for (subcategory of subcategories; track subcategory.id) {
          <mat-option [value]="subcategory">
            {{ subcategory.name }}
          </mat-option>
        }
      </mat-select>
      @if (lockNameAndCategories) {
        <mat-icon matSuffix class="lock-icon">lock</mat-icon>
      }
    </mat-form-field>
  </div>

  <div class="form-field-container percentage-fields-container">Enter measurement percentages</div>
  <div class="form-field-container percentage-fields-container">
    @for (measurement of measurements; track measurement) {
      <div class="percentage-field">
        <mat-form-field appearance="fill" class="form-field percentage-field">
          <mat-label>({{ measurement }})</mat-label>
          <input matInput type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="directPercentage_{{ measurement }}">
        </mat-form-field>
      </div>
    }
  </div>
</form>
